// extracted by mini-css-extract-plugin
export var phone = "_4o-0";
export var phoneDragging = "_4o-1";